import {connect} from "react-redux";
import UCDCasesEdit from "./CaseEdit";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../../service/fileUpload/action";
import {
    ucdById,
    carBrandRequest,
    carModelRequest,
    carVariantRequest,
    bankListRequest,
    addCaseRequest,
    loanApplicationByIdRequest,
    loanApplicationUpdateRequest,
    loanAccountRequest,
    newBankDetailsRequest,
    vehicleDetailsRequest
} from "../../../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    ucdDetails: state.Dealer.ucdDetails,
    ucsUpdateResponse: state.Dealer.ucdUpdate,
    addCaseResponse: state.Dealer.addCaseResponse,
    carBrandResponse: state.Dealer.carBrandResponse,
    carModelResponse: state.Dealer.carModelResponse,
    carVariantResponse: state.Dealer.carVariantResponse,
    bankListResponse: state.Dealer.bankListResponse,
    loanApplicationUpdateResponse: state.Dealer.loanApplicationUpdateResponse,
    ucdCaseByIdResponse: state.Dealer.loanApplicationByIdResponse,
    loanAccountResponse: state.Dealer.loanAccountResponse,
    newBankDetailsResponse: state.Dealer.newBankDetailsResponse,
    vehicleDetailsResponse: state.Dealer.vehicleDetailsResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            ucdById,
            carBrandRequest,
            carModelRequest,
            carVariantRequest,
            bankListRequest,
            addCaseRequest,
            loanApplicationByIdRequest,
            loanApplicationUpdateRequest,
            loanAccountRequest,
            newBankDetailsRequest,
            vehicleDetailsRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UCDCasesEdit);
